import React from 'react';
import PropTypes from 'prop-types';
import CrewModal from './CrewModal';

const EditCrewModal = ({ isOpen, crew, trainingGroups, onClose, onCrewChange, onSubmit }) => {
  // Don't render if modal is not open or crew is null
  if (!isOpen || !crew) return null;

  return (
    <CrewModal
      isOpen={isOpen}
      crew={crew}
      trainingGroups={trainingGroups}
      onClose={onClose}
      onCrewChange={onCrewChange}
      onSubmit={onSubmit}
      mode="edit"
    />
  );
};

EditCrewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  crew: PropTypes.object,
  trainingGroups: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onCrewChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default EditCrewModal;
